export enum SplitFeatureFlags {
  DD4533_NEW_TOP_LEVEL_NAVIGATION = 'DD-4533-new-top-level-navigation',
  KK_1590_SUNRISE_INTEGRATION = 'KK-1590-sunrise_integration',
  PKP_4866_RESTAGE = 'PKP-4866_Restage',
  KK_1913_Neighbourhood_AI_Guide = 'KK-1913-Neighbourhood-AI-Guide',
  KK_2784_EMAIL_VERIFICATION_FLOWS_PDP = 'KK-2784_Email-Verification-Flows-PDP',
}
